import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const Testimonials = () => {


  const testimonials = [
    {
      id: 1,
      quote: "Rasoha Academy has been an incredible experience for our family. The teachers are dedicated, the curriculum is challenging yet engaging, and the school community is warm and supportive. Our daughter has grown academically and personally in ways we never imagined.",
      name: "Sarah Johnson",
      role: "Parent",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      childGrade: "Grade 8"
    },
    {
      id: 2,
      quote: "As a student at Rasoha Academy, I've discovered my passion for science and technology. The hands-on learning approach and supportive teachers have helped me excel in my studies. The extracurricular activities have also helped me develop leadership skills.",
      name: "Michael Chen",
      role: "Student",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      grade: "Grade 11"
    },
    {
      id: 3,
      quote: "The academic foundation I received at Rasoha Academy prepared me exceptionally well for university. The critical thinking skills and study habits I developed here continue to serve me in my college studies. I'm grateful for the excellent education I received.",
      name: "Emily Rodriguez",
      role: "Alumni",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      graduationYear: "2022",
      university: "Stanford University"
    },
    {
      id: 4,
      quote: "What sets Rasoha Academy apart is their commitment to character development alongside academic excellence. My children have learned not just math and science, but also values like integrity, compassion, and responsibility. The school truly nurtures the whole child.",
      name: "David Thompson",
      role: "Parent",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      children: "2 children enrolled"
    },
    {
      id: 5,
      quote: "The teachers at Rasoha Academy are exceptional. They go above and beyond to ensure every student succeeds. The small class sizes allow for personalized attention, and the innovative teaching methods make learning exciting and engaging.",
      name: "Lisa Wang",
      role: "Parent",
      avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      childGrade: "Grade 5"
    },
    {
      id: 6,
      quote: "I've been teaching at Rasoha Academy for over 10 years, and I can honestly say this is the most supportive and innovative educational environment I've ever worked in. The administration values teacher input, and the students are motivated and eager to learn.",
      name: "Dr. Robert Martinez",
      role: "Teacher",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      subject: "Mathematics",
      experience: "15 years"
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <FaStar
        key={index}
        className={`w-4 h-4 ${
          index < rating
            ? 'text-yellow-400'
            : 'text-gray-300 dark:text-gray-600'
        }`}
      />
    ));
  };

  return (
    <section className="py-20 bg-white dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            What Our Community Says
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Hear from parents, students, alumni, and teachers about their experiences at Rasoha Academy
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative" data-aos="zoom-in">
          <Carousel
            showArrows={true}
            showThumbs={false}
            showStatus={false}
            showIndicators={true}
            infiniteLoop={true}
            autoPlay={true}
            interval={6000}
            stopOnHover={true}
            swipeable={true}
            emulateTouch={true}
            onChange={(index) => console.log('Current slide:', index)}
            className="testimonials-carousel"
          >
            {testimonials.map((testimonial, index) => (
              <div key={testimonial.id} className="px-4">
                <div className="bg-gray-50 dark:bg-gray-900 rounded-2xl p-8 md:p-12 shadow-lg">
                  {/* Quote Icon */}
                  <div className="flex justify-center mb-6">
                    <FaQuoteLeft className="w-8 h-8 text-blue-600 dark:text-blue-400" />
                  </div>

                  {/* Quote Text */}
                  <div className="text-center mb-8">
                    <p className="text-lg md:text-xl text-gray-700 dark:text-gray-300 leading-relaxed italic">
                      "{testimonial.quote}"
                    </p>
                  </div>

                  {/* Rating */}
                  <div className="flex justify-center mb-6">
                    <div className="flex space-x-1">
                      {renderStars(testimonial.rating)}
                    </div>
                  </div>

                  {/* Author Info */}
                  <div className="flex items-center justify-center">
                    <div className="flex items-center space-x-4">
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="w-16 h-16 rounded-full object-cover border-4 border-white dark:border-gray-700 shadow-lg"
                      />
                      <div className="text-center md:text-left">
                        <h4 className="font-semibold text-gray-900 dark:text-white text-lg">
                          {testimonial.name}
                        </h4>
                        <p className="text-blue-600 dark:text-blue-400 font-medium">
                          {testimonial.role}
                        </p>
                        {testimonial.childGrade && (
                          <p className="text-sm text-gray-600 dark:text-gray-400">
                            {testimonial.childGrade}
                          </p>
                        )}
                        {testimonial.grade && (
                          <p className="text-sm text-gray-600 dark:text-gray-400">
                            {testimonial.grade}
                          </p>
                        )}
                        {testimonial.graduationYear && (
                          <p className="text-sm text-gray-600 dark:text-gray-400">
                            Class of {testimonial.graduationYear} • {testimonial.university}
                          </p>
                        )}
                        {testimonial.children && (
                          <p className="text-sm text-gray-600 dark:text-gray-400">
                            {testimonial.children}
                          </p>
                        )}
                        {testimonial.subject && (
                          <p className="text-sm text-gray-600 dark:text-gray-400">
                            {testimonial.subject} • {testimonial.experience} experience
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-8" data-aos="fade-up">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2">
              98%
            </div>
            <div className="text-gray-600 dark:text-gray-300">
              Parent Satisfaction
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-green-600 dark:text-green-400 mb-2">
              100%
            </div>
            <div className="text-gray-600 dark:text-gray-300">
              College Acceptance
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-purple-600 dark:text-purple-400 mb-2">
              15:1
            </div>
            <div className="text-gray-600 dark:text-gray-300">
              Student-Teacher Ratio
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-orange-600 dark:text-orange-400 mb-2">
              25+
            </div>
            <div className="text-gray-600 dark:text-gray-300">
              Years of Excellence
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center" data-aos="fade-up">
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            Join Our Community
          </h3>
          <p className="text-gray-600 dark:text-gray-300 mb-8 max-w-2xl mx-auto">
            Experience the difference that quality education and a supportive community can make in your child's life.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-300 transform hover:scale-105">
              Schedule a Visit
            </button>
            <button className="border-2 border-blue-600 text-blue-600 dark:text-blue-400 px-8 py-3 rounded-lg font-semibold hover:bg-blue-600 hover:text-white transition-all duration-300 transform hover:scale-105">
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 